import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useMicrobranding } from '../../../utilities/hooks/useMicrobranding';
import { OidcDisplay } from '../../../types';
import { isOidcDisplayMode } from '../../../utilities/oidc/oidc';
import { FormattedMessage } from 'react-intl';
import { useRegisterComponent } from '../../orchestrator';

export const LoginLink = ({ children }: { children?: React.ReactNode }) => {
  useRegisterComponent(LoginLink.name);

  const location = useLocation();

  const { isEmbedded, oidcContext } = useMicrobranding();

  const loginLink = '/login' + location.search;

  if (isEmbedded) {
    return null;
  }

  if (isOidcDisplayMode(oidcContext, OidcDisplay.Signup)) {
    return null;
  }

  return (
    <Link id="already-have-an-account" to={loginLink}>
      {children || (
        <>
          <FormattedMessage
            id="signup.already.have.account.log.in"
            defaultMessage="Already have an Atlassian account? Log in"
          />
        </>
      )}
    </Link>
  );
};
